import LockedPreview from './LockedPreview';
import { InfoIcon } from './views/ViewCard';

export const LockedViewCard = ({ title, subtitle, info, onSignInClick, seed = 0 }) => (
  <section className="relative rounded-2xl border border-f1-border bg-f1-surface overflow-hidden min-h-[260px]">
    <header className="px-5 pt-5 pb-3 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <h3 className="text-sm font-semibold tracking-tight text-f1-text">{title}</h3>
        {subtitle && <p className="text-xs text-f1-muted mt-0.5">{subtitle}</p>}
      </div>
      {info && <InfoIcon info={info} />}
    </header>
    <div className="relative h-[200px]">
      <div className="absolute inset-0 filter blur-[4px] opacity-60">
        <LockedPreview seed={seed} />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-f1-surface/90 via-f1-surface/40 to-transparent" />
      <div className="absolute inset-0 grid place-items-center">
        <div className="flex flex-col items-center gap-2">
          <button
            onClick={onSignInClick}
            className="text-xs rounded-md bg-f1-red px-3 py-1.5 font-semibold hover:opacity-90 transition-opacity"
          >
            Sign in
          </button>
        </div>
      </div>
    </div>
  </section>
);
